import { render, staticRenderFns } from "./DocumentActionsModal.vue?vue&type=template&id=c9b05ab6"
import script from "./DocumentActionsModal.vue?vue&type=script&lang=js"
export * from "./DocumentActionsModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentActionsModal.vue?vue&type=style&index=0&id=c9b05ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports